import { Component, OnInit, OnDestroy, HostListener, ElementRef } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-topnav',
  templateUrl: './top-nav.component.html',
  styleUrls: ['./top-nav.component.scss']
})
export class TopNavComponent implements OnInit, OnDestroy {
  private static readonly MOBILE_WIDTH_THRESHOLD: number = 992;
  private static readonly MOBILE_SCROLLING_THRESHOLD: number = 40;
  private static readonly DEFAULT_SCROLLING_THRESHOLD: number = 60;

  private ngUnsubscribe: Subject<void>; //Permet de grabber tout ce qu'on doit finallement unsubscribe.

  public navScrolling: boolean;

  private toggleActif = false;

  public currentLanguage: string;


  constructor(private dialog: MatDialog, private elementRef: ElementRef, private translate: TranslateService) { 

    this.currentLanguage = this.translate.currentLang;
    this.ngUnsubscribe = new Subject<void>();
  }

  ngOnInit() {

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.currentLanguage = event.lang
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }​​​​​​​​

  @HostListener('window:scroll', ['$event'])
  public onWindowScroll(event) {
    const doc = document.documentElement;
    const top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);

    const threshold = doc.clientWidth < TopNavComponent.MOBILE_WIDTH_THRESHOLD
      ? TopNavComponent.MOBILE_SCROLLING_THRESHOLD
      : TopNavComponent.DEFAULT_SCROLLING_THRESHOLD;

    this.navScrolling = top > threshold;
  }

  public onClickNavBarToggler() {
    this.toggleActif = !this.toggleActif;
  }

  onCloseMenu(event) {
    const menu = this.elementRef.nativeElement.querySelectorAll('#navbarSupportedContent') as HTMLElement[];
    if (menu[0].classList.contains('show')) {
      const hamburger = this.elementRef.nativeElement.querySelectorAll('.navbar-toggler') as HTMLElement[];
      hamburger[0].click();
    }
  }

  doChangeLanguage(event, lang) {
    event.preventDefault();
    this.translate.use(lang);
  }

  goPP2() {
    window.location.href='https://www.plurilogic.com/pluriportail/fr/MainExterne.srf?P=LoginReq';
  }
  
}
